import {
    BackButton,
    convertFromBoolean,
    convertToBoolean,
    Divider,
    Form,
    FormDropDown,
    FormInput,
    FormRadio,
    Header,
    useAlignments,
    useSizes,
} from 'metrix-common3';
import React from 'react';
import { FormattedMessage } from 'react-intl';

const ProfileVehicleUse = (props) => {
    const sizes = useSizes();
    const alignments = useAlignments();

    return (
        <React.Fragment>
            <BackButton clickEvent={props.backEvent} />
            <Divider top={sizes.md} />
            <Header
                size={sizes.md}
                textAlign={alignments.left}
                text={<FormattedMessage id='Profile_Vehicles_VehicleUse.vehicleUsage' />}
            />
            <Form
                label={<FormattedMessage id='Profile_Vehicles_VehicleUse.driverDetails' />}
                saveEvent={() => props.doUpsertPolicy()}
                cancelEvent={() => props.doGetPolicy()}
                allowEdit={props.allowEdit}
            >
                <FormDropDown
                    label={<FormattedMessage id='Profile_Vehicles_VehicleUse.driver' />}
                    value={
                        props.vehicleUse && {
                            code: props.vehicleUse.driver,
                        }
                    }
                    references={props.drivers}
                    // biome-ignore lint/suspicious/noEmptyBlockStatements: noop callback for referencesEvent contract
                    referencesEvent={() => {}}
                    changeEvent={(value) => {
                        props.doReducePolicyElement({ code: `${props.dotProp}driver`, value: value.code });
                    }}
                    allowEdit
                />
                <FormInput
                    label={<FormattedMessage id='Profile_Vehicles_VehicleUse.usePercentage' />}
                    value={props.vehicleUse?.percentage}
                    changeEvent={(value) => {
                        props.doReducePolicyElement({ code: `${props.dotProp}percentage`, value });
                    }}
                    allowEdit
                />
                <FormRadio
                    label={<FormattedMessage id='Profile_Vehicles_VehicleUse.primaryDriver' />}
                    value={props.vehicleUse && { code: convertFromBoolean(props.vehicleUse.primary) }}
                    references={props.reference.references?.YesNo}
                    referencesEvent={() => props.reference.doGetReferences('YesNo')}
                    changeEvent={(value) =>
                        props.doReducePolicyElement({
                            code: `${props.dotProp}primary`,
                            value: convertToBoolean(value.code),
                        })
                    }
                    allowEdit
                />
                <FormRadio
                    label={<FormattedMessage id='Profile_Vehicles_VehicleUse.vehicleOwner' />}
                    value={props.vehicleUse && { code: convertFromBoolean(props.vehicleUse.owner) }}
                    references={props.reference.references?.YesNo}
                    referencesEvent={() => props.reference.doGetReferences('YesNo')}
                    changeEvent={(value) =>
                        props.doReducePolicyElement({
                            code: `${props.dotProp}owner`,
                            value: convertToBoolean(value.code),
                        })
                    }
                    allowEdit
                />
            </Form>
        </React.Fragment>
    );
};

export default ProfileVehicleUse;
